<template>
  <v-card>
    <v-container>
      <v-skeleton-loader
        :loading="skeleton"
        class="mx-auto"
        min-height="410"
        type="card-heading, list-item-three-line@3, actions"
      >
        <form>
          <v-row class="pb-4">
            <v-col>
              <v-icon> mdi-clock-fast </v-icon>
              <span class="headline mx-2">Login Periods</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              class="py-0" 
              cols="12" 
              lg="6"
            >
              <v-text-field
                v-if="!edit"
                :value="weekdayStartDisplay"
                label="Weekday Start"
                filled
                readonly            
              />
              <v-menu
                v-else
                id="date"
                v-model="weekdayStartMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                @input="setSelectorBacktoHour"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="weekdayStartDisplay"
                    label="Weekday Start"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  />
                </template>

                <v-time-picker
                  ref="picker"
                  v-model="form.weekdayStart"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="weekdayStartMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col 
              class="py-0"
              cols="12" 
              lg="6"
            >
              <v-text-field
                v-if="!edit"
                :value="weekdayEndDisplay"
                label="Weeday End"
                filled
                readonly            
              />
              <v-menu
                v-else
                id="date"
                v-model="weekdayEndMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                @input="setSelectorBacktoHour"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="weekdayEndDisplay"
                    label="Weekday End"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  />
                </template>

                <v-time-picker
                  ref="picker"
                  v-model="form.weekdayEnd"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="weekdayEndMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              class="py-0"
              cols="12" 
              lg="6"
            >
              <v-text-field
                v-if="!edit"
                :value="saturdayStartDisplay"
                label="Saturday Start"
                filled
                readonly            
              />
              <v-menu
                v-else
                id="date"
                v-model="saturdayStartMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                @input="setSelectorBacktoHour"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="saturdayStartDisplay"
                    label="Saturday Start"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  />
                </template>

                <v-time-picker
                  ref="picker"
                  v-model="form.saturdayStart"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="saturdayStartMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col 
              class="py-0"
              cols="12" 
              lg="6"
            >
              <v-text-field
                v-if="!edit"
                :value="saturdayEndDisplay"
                label="Saturday End"
                filled
                readonly            
              />
              <v-menu
                v-else
                id="date"
                v-model="saturdayEndMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                @input="setSelectorBacktoHour"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="saturdayEndDisplay"
                    label="Saturday End"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  />
                </template>

                <v-time-picker
                  ref="picker"
                  v-model="form.saturdayEnd"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="saturdayEndMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              class="py-0"
              cols="12" 
              lg="6"
            >
              <v-text-field
                v-if="!edit"
                :value="sundayStartDisplay"
                label="Sunday Start"
                filled
                readonly            
              />
              <v-menu
                v-else
                id="date"
                v-model="sundayStartMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                @input="setSelectorBacktoHour"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="sundayStartDisplay"
                    label="Sunday Start"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  />
                </template>

                <v-time-picker
                  ref="picker"
                  v-model="form.sundayStart"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="sundayStartMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col 
              class="py-0"
              cols="12" 
              lg="6"
            >
              <v-text-field
                v-if="!edit"
                :value="sundayEndDisplay"
                label="Sunday End"
                filled
                readonly            
              />
              <v-menu
                v-else
                id="date"
                v-model="sundayEndMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                @input="setSelectorBacktoHour"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="sundayEndDisplay"
                    label="Sunday End"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  />
                </template>

                <v-time-picker
                  ref="picker"
                  v-model="form.sundayEnd"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="sundayEndMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row> 
          <v-card-actions v-if="$hasPermissionTo(['update login periods']) && !$store.state.isMyProfile">
            <v-spacer />
            <v-btn
              v-if="!edit"
              color="info"
              @click="editForm"
            >
              Edit
            </v-btn>
            <div v-else>
              <v-btn
                :disabled="progressing"
                text
                @click="edit = false"
              >
                Cancel
              </v-btn>
              <v-btn          
                :loading="progressing"
                color="success"
                @click="submitForm"
              >
                Update
              </v-btn>
            </div>
          </v-card-actions>
        </form>
      </v-skeleton-loader>
    </v-container>
  </v-card>
</template>

<script>
  export default {
    props: {
      userUid: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        skeleton: true,
        progressing: false,
        edit: false,
      
        formValid: true,

        weekdayStart: null,
        weekdayEnd: null,
        saturdayStart: null,
        saturdayEnd: null,
        sundayStart: null,
        sundayEnd: null,
      
        form: {
          weekdayStart: null,
          weekdayEnd: null,
          saturdayStart: null,
          saturdayEnd: null,
          sundayStart: null,
          sundayEnd: null,
        },
        weekdayStartMenu: false,
        weekdayEndMenu: false,
        saturdayStartMenu: false,
        saturdayEndMenu: false,
        sundayStartMenu: false,
        sundayEndMenu: false,
      }
    },
    computed: {
      weekdayStartDisplay () {
        return this.edit ? this.formatTime(this.form.weekdayStart) : this.formatTime(this.weekdayStart)
      },
      weekdayEndDisplay () {
        return this.edit ? this.formatTime(this.form.weekdayEnd) : this.formatTime(this.weekdayEnd)
      },
      saturdayStartDisplay () {
        return this.edit ? this.formatTime(this.form.saturdayStart) : this.formatTime(this.saturdayStart)
      },
      saturdayEndDisplay () {
        return this.edit ? this.formatTime(this.form.saturdayEnd) : this.formatTime(this.saturdayEnd)
      },
      sundayStartDisplay () {
        return this.edit ? this.formatTime(this.form.sundayStart) : this.formatTime(this.sundayStart)
      },
      sundayEndDisplay () {
        return this.edit ? this.formatTime(this.form.sundayEnd) : this.formatTime(this.sundayEnd)
      },
    },
    watch: {
      userUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.$resetData()
            this.loadUserLoginPeriods()
          }
        },
      },
    },
    methods: {
      loadUserLoginPeriods () {
        this.$api.loginPeriods().list(this.userUid)
          .then(response => {
            this.setLocalData(response.data)          
          })
          .catch(() => {})
          .then(() => {
            this.skeleton = false
          })
      },
      submitForm () {
        this.progressing = true

        this.$api.loginPeriods().update(this.userUid, this.prepareFormData())
          .then((res) => {
            if (res.status >= 200 && res.status < 300) {
              this.$snack({
                message: res.data.status,
              })

              this.updated()
            }
          })
          .catch(() => {})
          .then(() => {
            this.progressing = false
          })       
      },   
      editForm () {
        Object.keys(this.form).map(key => {
          this.form[key] = this[key] || this.$moment(new Date()).format('hh:mm')
        })
  
        this.edit = true
      },
      updated () {
        Object.keys(this.form).map(key => {
          this[key] = this.form[key] 
        })

        this.edit = false
      },
      prepareFormData () {
        return [
          {
            day: 5,
            start_time: this.form.weekdayStart,
            end_time: this.form.weekdayEnd,
          },
          {
            day: 6,
            start_time: this.form.saturdayStart,
            end_time: this.form.saturdayEnd,
          },
          {
            day: 7,
            start_time: this.form.sundayStart,
            end_time: this.form.sundayEnd,
          },
        ]
      },
      setSelectorBacktoHour () {
        if (this.$refs.picker) {
          this.$refs.picker.selectingHour = true
        }
      },
      setLocalData (loginPeriods) {
        loginPeriods.map(loginPeriod => {
          if (loginPeriod.day === 5) {
            this.weekdayStart = loginPeriod.start_time
            this.weekdayEnd = loginPeriod.end_time
          } else if (loginPeriod.day === 6) {
            this.saturdayStart = loginPeriod.start_time
            this.saturdayEnd = loginPeriod.end_time
          } else if (loginPeriod.day === 7) {
            this.sundayStart = loginPeriod.start_time
            this.sundayEnd = loginPeriod.end_time
          }
        })
      },
      formatTime (time) {
        let a = (time || '').split(':') // split it at the colons
        let seconds = (a[0] * 60 * 60) + (a[1] * 60)

        return this.$moment(new Date(1970, 0, 1).setSeconds(seconds)).format('hh:mm A')
      },
    },
  }
</script>
